import { action } from '../dispatchAction'
import { USER_ACTION_TYPES } from '../user/types'
import ActionTypes from './types'

import { getColIdFromEmail } from '../user/getColIdFromEmail'

import { abilityKeys } from '../../data/abitilies/interfaces/IAbilityData'

import * as moment from 'moment'

import { database, databaseRef, functions, storageRef } from 'config/firebase'
import { gamesInTypes } from '../../data/games/gameTypes'
import FormType, { formTypeRefs } from '../../data/questionnaires/FormType'

import talentsData from 'data/abitilies'
import { trackedAbilities } from 'data/abitilies/childsAbilities'
import { ISetAnswersParams } from 'data/questionnaires/IQuestionAnswer'
import { get } from 'lodash'
import mixpanel from 'mixpanel-browser'
import { Dispatch } from 'react'
import { IReduxAction } from 'reducers/IReduxAction'
import { chartAbilties, updateAbilityData } from 'services/normativeData'
import { getAge } from 'services/utils'
import IChild from 'types/database/children/child'
import IAbilities from 'types/database/children/child/abilities'
import IAssessments from 'types/database/children/child/assessments'
import IUser, { IRole } from 'types/database/users/user'
import { IPupil } from 'types/database/users/user/pupils'
import IPatient from 'types/store/patients/patients/patient'
import {
  getChildrenIds,
  getCurrentAssessment,
  getCurrentAssessmentTimestamp,
  getDefaultAssessment,
  isBaseFormCompleted,
  isFormsStarted,
  isGamesDone
} from '../../services/patient'

// export const getPatientsFromDb = async (userId, userData) => {
//   return new Promise(async (resolve, reject) => {
//     const childRef = databaseRef.child(`children`)
//     // const arr = ['first_name', 'created_at']

//     const childrenIDs: string[] = userData.children
//       ? Object.values(userData.children)
//       : []

//     const children: any[] = []

//     try {
//       for (const childId of childrenIDs) {
//         try {
//           const child = await Promise.all([
//             childRef
//               .child(childId)
//               .child('first_name')
//               .once('value'),
//             childRef
//               .child(childId)
//               .child('birth_date')
//               .once('value'),

//             await childRef
//               .child(childId)
//               .child('parents')
//               .once('value'),
//             childRef
//               .child(childId)
//               .child('patient_avatar')
//               .once('value'),
//             childRef
//               .child(childId)
//               .child('gender')
//               .once('value')
//           ])

//           const newArr = child.map(key => key.val())

//           const [
//             first_name,
//             birth_date,
//             parents,
//             patient_avatar,
//             gender
//           ] = newArr

//           if (parents[userId]) {
//             children.push({
//               first_name,
//               birth_date,
//               parents,
//               patient_avatar,
//               gender,
//               patientId: childId
//             })
//           }
//         } catch (error) {
//           console.log('error', error)
//         }
//       }
//       children.sort((a, b) => a.created_at - b.created_at)
//       resolve(children)
//     } catch (error) {
//       reject(error)
//     }
//   })
// }

const getChildFromDb = (childId: string) => {
  return new Promise<IChild>(async (resolve, reject) => {
    try {
      const child = (
        await databaseRef
          .child('children')
          .child(childId)
          .once('value')
      ).val()

      resolve(child)
    } catch (error) {
      console.log('error', error)
      reject(error)
    }
  })
}

const getPatientsFromDb = (userId: string, userData: IUser) => {
  return new Promise<Array<IChild & { patientId: string }>>(
    async (resolve, reject) => {
      const parent = userData?.role === IRole.parent
      const childrenIDs = getChildrenIds(userData)

      const children: Array<IChild & {
        patientId: string
        currentAssessment: string | number
        metaInfo?: IPupil
      }> = []
      try {
        for (const childId of childrenIDs) {
          try {
            const child: IChild = await getChildFromDb(childId)
            if (parent) {
              if (child && child.parents && child.parents[userId]) {
                children.push({
                  ...child,
                  patientId: childId,
                  currentAssessment: getCurrentAssessmentTimestamp({
                    ...child,
                    patientId: childId
                  })
                })
              }
            } else {
              if (child && child.educators && child.educators[userId]) {
                children.push({
                  ...child,
                  patientId: childId,
                  currentAssessment: getCurrentAssessmentTimestamp({
                    ...child,
                    patientId: childId
                  }),
                  metaInfo: userData.pupils[childId]
                })
              }
            }
          } catch (error) {
            console.log('error', error)
          }
        }

        children.sort((a, b) => a.created_at - b.created_at)
        resolve(children)
      } catch (error) {
        reject(error)
      }
    }
  )
}

export const uploadImage = (
  image: Blob,
  successCallback: (url: string) => void = () => {
    return
  },
  errorCallback: (message: string) => void = () => {
    return
  }
) => async () => {
  const name = `images/${+new Date()}.jpeg`
  storageRef
    .child(name)
    .put(image)
    .then(snapshot => snapshot.ref.getDownloadURL())
    .then(url => successCallback(url))
    .catch(error => {
      const { message } = error
      errorCallback(message)
    })
}

export const uploadReport = (
  report: Blob,
  patientId: string,
  iterator: number,
  successCallback: (url: string) => void = () => {
    return
  },
  errorCallback: (message: string) => void = () => {
    return
  }
) => async () => {
  const name = `reports/${+new Date()}.pdf`
  storageRef
    .child(name)
    .put(report)
    .then(snapshot => snapshot.ref.getDownloadURL())
    .then(url => {
      database.ref(`children/${patientId}/reports/${iterator}/pdf`).set(url)
      successCallback(url)
    })
    .catch(error => {
      const { message } = error
      errorCallback(message)
    })
}

export const getReports = (
  userId: string,
  successCallback: (forms: any[]) => void = () => {
    return
  },
  errorCallback: (message: string) => void = () => {
    return
  }
) => async dispatch => {
  databaseRef
    .child(`children/${userId}/reports`)
    .once('value')
    .then(snapshot => {
      const reports = snapshot.val()
      dispatch(
        action(ActionTypes.get_reports_success, {
          reports
        })
      )
    })
    .catch(error => {
      const { code, message } = error
      dispatch(
        action(ActionTypes.get_reports_error, {
          code,
          message
        })
      )

      errorCallback(message)
    })
}

export const addReport = (
  report: any,
  patientId: string,
  position: number,
  successCallback: () => void = () => {
    return
  },
  errorCallback: (message: string) => void = () => {
    return
  }
) => async dispatch => {
  database
    .ref(`children/${patientId}/reports/${position}`)
    .set(report)
    .then(() => {
      dispatch(
        action(ActionTypes.add_report_success, {
          report,
          patientId
        })
      )
      successCallback()
    })
    .catch(error => {
      const { code, message } = error
      dispatch(
        action(ActionTypes.add_report_error, {
          code,
          message
        })
      )
      errorCallback(message)
    })
}

export const updateReport = (
  report: any,
  patientId: string,
  position: number,
  successCallback: () => void = () => {
    return
  },
  errorCallback: (message: string) => void = () => {
    return
  }
) => async dispatch => {
  database
    .ref(`children/${patientId}/reports/${position}`)
    .update(report)
    .then(() => {
      dispatch(action(ActionTypes.update_report, { report, position }))
      successCallback()
    })
    .catch(error => {
      console.log(error)
      errorCallback(error)
    })
}

export const savePatient = (
  patientData: any,
  parentData: any,
  educatorData: any,
  successCallback: (children: any, patientId?: any) => void = () => {
    return
  },
  errorCallback: (message: string) => void = () => {
    return
  }
) => async (dispatch, getState) => {
  const { user } = getState()
  const userData = user.data
  const userId = user.auth.uid

  if (!userId) {
    const errObj = {
      code: 404,
      message: 'User not found. Please login again'
    }

    const { message } = errObj

    errorCallback(message)
    return
  }

  if (
    userData.children &&
    userData.children[patientData.first_name.toLowerCase()]
  ) {
    const errObj = {
      code: 404,
      message: `Child with name ${patientData.first_name} already exist`
    }
    const { message } = errObj

    errorCallback(message)
    return
  }

  const currentTimestamp = moment().unix()

  const abilities: IAbilities = {}

  abilityKeys.forEach(key => (abilities[key] = -1))

  const assessments: IAssessments = {
    relevant_assessment: currentTimestamp,
    [currentTimestamp]: {
      results_ready_not_shown: true,
      ...getDefaultAssessment(patientData)
    },
    created_at: currentTimestamp,
    updated_at: currentTimestamp,
    enabled: true
  }

  const patientDetails: IChild = {
    ...patientData,
    parents: {
      [parentData.id_parent ||
      getColIdFromEmail(parentData.email)]: !!parentData.id_parent
    },
    abilities,
    assessments,
    created_at: currentTimestamp,
    updated_at: currentTimestamp,
    enabled: true
  }

  const pushNewPatient = database.ref('children').push()

  pushNewPatient
    .set(patientDetails)
    .then(() => {
      if (userId && pushNewPatient.key) {
        const name = patientData.first_name.toLowerCase().trim()
        if (!userData.children) {
          userData.children = {
            [name]: pushNewPatient.key
          }
        } else {
          userData.children[name] = pushNewPatient.key
        }

        database
          .ref(`users/${userId}`)
          .set({
            ...userData,
            userId: null,
            terms_not_accepted: null
          })
          .then(() => {
            dispatch(
              action(USER_ACTION_TYPES.update_user_success, {
                userData
              })
            )
            successCallback(userData.children, pushNewPatient.key)
          })
          .catch(error => {
            const { message } = error
            errorCallback(message)
          })
      } else {
        const { email, name } = parentData
        const firstName = name.split(' ')[0] || ''
        const lastName = name.split(' ')[1] || ''
        database
          .ref(`parents/${getColIdFromEmail(email)}`)
          .set({
            ...parentData,
            first_name: firstName,
            last_name: lastName,
            created_at: currentTimestamp,
            updated_at: currentTimestamp,
            enabled: false
          })
          .then(() => {
            successCallback({
              [patientData.name.replace(
                /[^a-zA-Z0-9 ]/g,
                ''
              )]: pushNewPatient.key
            })
          })
          .catch(error => {
            const { message } = error
            errorCallback(message)
          })
      }
    })
    .then(() => {
      dispatch(
        action(ActionTypes.save_new_patient, {
          patientDetails: {
            ...patientDetails,
            patientId: pushNewPatient.key
          }
        })
      )
    })
    .catch(error => {
      const { message } = error
      errorCallback(message)
    })
}

export const createNewRelevantAssessment = (
  childId: string,
  successCallback?: (child: IChild) => void,
  errorCallback?: (message: string) => void
) => async dispatch => {
  // const { user } = getState()
  // const userData: IUser = user.data
  // const userId: string = user.auth.uid

  // if (!userId) {
  //   const errObj = {
  //     code: 404,
  //     message: 'User not found. Please login again'
  //   }

  //   const { message } = errObj

  //   errorCallback(message)
  //   return
  // }

  const child = await getChildFromDb(childId)

  if (!child) {
    const errObj = {
      code: 404,
      message: 'Child does not exist'
    }

    const { message } = errObj

    if (errorCallback) {
      errorCallback(message)
    }
    return
  }

  const currentTimestamp = moment().unix()

  Object.assign(child.assessments, {
    relevant_assessment: currentTimestamp,
    [currentTimestamp]: {
      results_ready_not_shown: true,
      ...getDefaultAssessment(child)
    },
    updated_at: currentTimestamp
  })

  editPatient(child, childId, successCallback, errorCallback)(dispatch)
}

// export const changeRelevantAssessment = (
//   childId: string,
//   relevantAssessment: IAssessments['relevant_assessment'],
//   successCallback?: (child: IChild) => void,
//   errorCallback?: (message: string) => void
// ) => async dispatch => {
//   const child = await getChildFromDb(childId)

//   if (!child) {
//     const errObj = {
//       code: 404,
//       message: 'Child does not exist'
//     }

//     const { message } = errObj

//     if (errorCallback) {
//       errorCallback(message)
//     }

//     return
//   }

//   const assessment = child.assessments[relevantAssessment]

//   if (!assessment) {
//     const errObj = {
//       code: 404,
//       message: 'Assessment does not exist'
//     }

//     const { message } = errObj

//     if (errorCallback) {
//       errorCallback(message)
//     }

//     return
//   }

//   const currentTimestamp = moment().unix()

//   Object.assign(child.assessments, {
//     relevant_assessment: relevantAssessment,
//     updated_at: currentTimestamp
//   })

//   editPatient(child, childId, successCallback, errorCallback)(dispatch)
// }

export const setCurrentAssessment = (
  childId: string,
  currentAssessmentTimestamp: string,
  successCallback?: () => void,
  errorCallback?: (message: string) => void
) => async (dispatch: Dispatch<IReduxAction>) => {
  const child = await getChildFromDb(childId)

  if (!child) {
    if (errorCallback) {
      errorCallback('Child does not exist')
    }

    return
  }

  const assessment = child.assessments[currentAssessmentTimestamp]

  if (!assessment) {
    if (errorCallback) {
      errorCallback('Assessment does not exist')
    }

    return
  }

  dispatch(
    action(ActionTypes.set_current_assessment, {
      childId,
      currentAssessmentTimestamp
    })
  )

  if (successCallback) {
    successCallback()
  }
}

export const getPatients = (
  successCallback: (patients: any) => void = () => {
    return
  },
  errorCallback: (message: string) => void = () => {
    return
  }
) => async (dispatch, getState) => {
  dispatch(action(ActionTypes.get_all_patients_begins))

  const { user } = getState()

  const userId = user.auth.uid

  if (!userId) {
    const errObj = {
      code: 404,
      message: 'User not found. Please login again'
    }

    const { code, message } = errObj

    dispatch(
      action(ActionTypes.get_all_patients_error, {
        code,
        message
      })
    )
    errorCallback(message)
    return
  }

  getPatientsFromDb(userId, user.data)
    .then(patients => {
      dispatch(
        action(ActionTypes.get_all_patients_success, {
          patients
        })
      )

      successCallback(patients)
    })
    .catch(error => {
      const { code, message } = error
      dispatch(
        action(ActionTypes.get_all_patients_error, {
          code,
          message
        })
      )

      errorCallback(message)
    })
}

//// action for childListener change (and initial)
export const setChild = (childData: IPatient) => async (dispatch, getState) => {
  const {
    user: { data }
  } = getState()
  const { uid } = getState().user.auth
  // format the ability data
  childData.abilities = {
    ...childData.abilities,
    ...updateAbilityData(childData)
  }
  childData.formsFinished = isBaseFormCompleted(childData)
  childData.gamesFinished = isGamesDone(childData)
  childData.formsStarted = await isFormsStarted(childData, uid)
  childData.currentAssessment = getCurrentAssessmentTimestamp(childData)

  if (data.pupils && childData.patientId) {
    childData.metaInfo = data.pupils[childData.patientId]
  }
  dispatch(action(ActionTypes.set_curr_child, childData))
}
////

export const setCurrentPatient = (
  patientId: string,
  successCallback: (patient: any) => void = () => {
    return
  },
  errorCallback: (message: string) => void = () => {
    return
  }
) => async (dispatch, getState) => {
  dispatch(action(ActionTypes.set_current_patient_begins))

  const {
    patients,
    user: { data }
  } = getState()
  const { uid } = getState().user.auth

  try {
    const currentPatient = patientId
      ? patients.patients.find(item => item.patientId === patientId)
      : null
    if (currentPatient) {
      // format the ability data
      currentPatient.abilities = {
        ...currentPatient.abilities,
        ...updateAbilityData(currentPatient)
      }
      currentPatient.formsFinished = isBaseFormCompleted(currentPatient)
      currentPatient.gamesFinished = isGamesDone(currentPatient)
      currentPatient.formsStarted = await isFormsStarted(currentPatient, uid)
      currentPatient.currentAssessment = getCurrentAssessmentTimestamp(
        currentPatient
      )
      if (data.pupils) {
        currentPatient.metaInfo = data.pupils[patientId]
      }
    }

    dispatch(
      action(ActionTypes.set_current_patient_success, {
        currentPatient
      })
    )

    successCallback(currentPatient)
  } catch (error) {
    const { code, message } = error
    dispatch(
      action(ActionTypes.set_current_patient_error, {
        code,
        message
      })
    )

    errorCallback(message)
  }
}

export interface IUpdChildData {
  formsFinished: boolean
  gamesFinished: boolean
}

export const updateCurrentPatient = (
  child?: IPatient,
  callback: (data: IUpdChildData) => void = () => {
    return
  }
) => async (dispatch, getState) => {
  const { patientId } = getState().patients.currentPatient
  const { uid } = getState().user.auth
  const {
    user: { data }
  } = getState()
  let updatedChild: IPatient | undefined = child

  if (!updatedChild) {
    const record = await databaseRef
      .child('children')
      .child(patientId)
      .once('value')
    updatedChild = { ...record.val(), patientId }
  }

  if (!updatedChild) {
    return
  }

  // format the ability data
  updatedChild.abilities = {
    ...updatedChild.abilities,
    ...updateAbilityData(updatedChild)
  }

  updatedChild.formsFinished = isBaseFormCompleted(updatedChild)
  updatedChild.gamesFinished = isGamesDone(updatedChild)
  updatedChild.formsStarted = await isFormsStarted(updatedChild, uid)
  updatedChild.currentAssessment = getCurrentAssessmentTimestamp(updatedChild)

  if (data.pupils) {
    updatedChild.metaInfo = data.pupils[patientId]
  }

  dispatch(
    action(ActionTypes.update_current_patient, {
      currentPatient: updatedChild
    })
  )
  callback({
    formsFinished: updatedChild.formsFinished,
    gamesFinished: updatedChild.gamesFinished
  })
}

export const UpdateQuestionnarie = (
  isInRow: boolean = false,
  callback: () => void = () => {
    return
  }
) => async (dispatch, getState) => {
  dispatch(action(ActionTypes.set_questionnaries_in_row, isInRow))
  callback()
}

export const changeIsNew = (data: any) => dispatch => {
  database
    .ref(`children/${data.patientId}/isNew`)
    .set(null)

    .catch(error => {
      console.log(error)
    })
}

export const addCareProfessional = (
  patientId: string,
  careProfessionalId: string,
  forms: any[],
  successCallback: () => void = () => {
    return
  },
  errorCallback: (message: string) => void = () => {
    return
  }
) => async (dispatch, getState) => {
  const assignForm = index => {
    if (index === forms.length) {
      successCallback()
      return
    }

    database
      .ref(`forms/${forms[index].formId}/creator_id`)
      .set(careProfessionalId)
      .then(() => {
        index++
        assignForm(index)
      })
      .catch(() => {
        index++
        assignForm(index)
      })
  }

  database
    .ref(`children/${patientId}/id_care_professional`)
    .set(careProfessionalId)
    .then(() => {
      dispatch(
        action(ActionTypes.add_care_professional_success, {
          careProfessionalId
        })
      )
      assignForm(0)
    })
    .catch(error => {
      // dispatch(ActionTypes.add_care_professional_success)
      errorCallback(error)
    })
}

export const editPatient = (
  patientData: Partial<IChild>,
  patientId: string,
  successCallback?: (data: IChild) => void,
  errorCallback?: (message: string) => void
) => async dispatch => {
  database
    .ref(`children/${patientId}`)
    .update(patientData)
    .then(data => {
      dispatch(action(ActionTypes.update_current_patient, patientData))
      if (successCallback) {
        successCallback(data)
      }
    })
    .catch(error => {
      console.log('onedit error', error)
      if (errorCallback) {
        errorCallback(error)
      }
    })
}

export const updateResultsReadyShown = () => async (dispatch, getState) => {
  const { currentPatient } = getState().patients

  const relevantAssessment = currentPatient?.currentAssessment

  if (!relevantAssessment) {
    return
  }

  await databaseRef
    .child('children')
    .child(currentPatient.patientId)
    .child('assessments')
    .child(relevantAssessment)
    .child('results_ready_not_shown')
    .set(null)

  delete currentPatient.assessments[relevantAssessment].results_ready_not_shown
}

const revokeEducatorAccess = functions.httpsCallable('revokeEducatorAccess')
const revokeAccessToAllEducators = functions.httpsCallable(
  'revokeAccessToAllEducators'
)

export const deleteChild = (
  id: string,
  onSuccess: () => void = () => {
    return
  },
  onError: (error: string) => void = () => {
    return
  }
) => async (dispatch, getState) => {
  dispatch(action(ActionTypes.delete_child_start))

  // const patients = getState().patients.patients as any[]
  const {
    user,
    patients: { patients }
  } = getState()
  const userData = user.data
  const userId = user.auth.uid

  const child = patients.find(p => p.patientId === id)

  if (!child) {
    return
  }

  try {
    if (userData && userData.role === IRole.educator) {
      const revoke = await revokeEducatorAccess({
        educator_uid: userId,
        child_id: id
      })
      if (revoke && revoke.data) {
        if (revoke.data.error) {
          throw new Error(revoke.data.error)
        }
      } else {
        throw new Error('error occured while deleting child. try again later')
      }
    } else {
      const assessment = getCurrentAssessment(child)

      if (!assessment) {
        throw new Error('assessment not found')
      }
      const formRefs = { ...formTypeRefs }
      const age = getAge(child.birth_date, Number(child.currentAssessment))
      if (age <= 2 || age >= 9) {
        // delete formRefs.fine_motor
        // @ts-ignore
        delete formRefs.language
        // delete formRefs.gross_motor
      }
      const empty =
        Object.keys(gamesInTypes).every(key => !assessment[key]) &&
        Object.values(formRefs).every(
          key =>
            get(assessment, `${key}.total_results.total_score.score`) ===
            undefined
        )

      const childRef = databaseRef.child('children').child(id)

      if (empty) {
        childRef.remove()
      } else {
        const updates = {
          first_name: null,
          parents: null
        }

        childRef.update(updates)
      }

      mixpanel.identify(userId)
      mixpanel.track('delete child')

      if (child.educators) {
        const educators = Object.keys(child.educators) || []
        if (educators) {
          const revokeAll = await revokeAccessToAllEducators({
            euids: educators,
            child_id: id,
            delete_from_child: false
          })
          if (process.env.REACT_APP_IS_PROD !== 'true') {
            console.log('educators: ', educators)
            console.log('revokeall: ', revokeAll)
          }

          // if (revokeAll && revokeAll.data) {
          //   if (revokeAll.data.error) {
          //     throw new Error(revokeAll.data.error)
          //   }
          // } else {
          //   throw new Error(
          //     'error occured while deleting child. try again later'
          //   )
          // }
        }
      }
    }

    dispatch(action(ActionTypes.delete_child_success, { id }))
  } catch (error) {
    dispatch(action(ActionTypes.delete_child_error, { message: error }))
    onError(error)
  }
}

export const clear = () => async (dispatch, getState) => {
  dispatch(action(ActionTypes.clear))
}

export const setTalentChartMap = (
  patient: any,
  callback?: () => void
) => async (dispatch, getState) => {
  const {
    plus_user: { isPlusUser: plusUser }
  } = getState()

  const abilities = chartAbilties(patient)
  if (!abilities) {
    return
  }

  let talentsChartData: Array<{
    key: string
    label: string
    value: number
  }> = []
  const childAbiliriesKeys = trackedAbilities(patient)

  const filteredTalents = talentsData.filter(talent =>
    childAbiliriesKeys.includes(talent.key)
  )

  const isBasicUser = !plusUser
  const plusAbility = isBasicUser ? ['self-esteem', 'spatial'] : ['']
  const getValue = (value, ability) => {
    return isBasicUser && value !== -1 && !plusAbility.includes(ability)
      ? -2
      : value < -1
      ? -1
      : value
  }

  if (filteredTalents) {
    talentsChartData = filteredTalents.map(({ key, label }) => ({
      key,
      label,
      value: getValue(Math.ceil(abilities[key] as number), key)
    }))
  }

  dispatch(action(ActionTypes.set_talents_chart_map, talentsChartData))
  if (typeof callback === 'function') {
    callback()
  }
}

export const setAnswers = (
  setAnswersParams: ISetAnswersParams,
  callback?: () => void
) => (dispatch, getState) => {
  const {
    patients: { currentPatient }
  } = getState()

  if (currentPatient) {
    dispatch(
      action(ActionTypes.set_answers, {
        patientId: currentPatient.patientId,
        ...setAnswersParams
      })
    )
  }
  if (typeof callback === 'function') {
    callback()
  }
}

export const clearAnswers = (formType: FormType, callback?: () => void) => (
  dispatch,
  getState
) => {
  const {
    patients: { currentPatient }
  } = getState()

  if (currentPatient) {
    dispatch(
      action(ActionTypes.clear_answers, {
        currentPatientId: currentPatient.patientId,
        formType
      })
    )
  }
  if (typeof callback === 'function') {
    callback()
  }
}



// WEBPACK FOOTER //
// ./src/store/patients/actions.ts